module.exports = __webpack_public_path__ + "static/media/1007029.6a156061.jpg";